<template>
  <div>
   <!--<login :show.sync="show"></login>--> 
    <div v-if="!toTop" class="nav-info w-100 c-ffffff">
      <div class="mar-left30 fl-left">
          <router-link :to="{path:'/'}"><img width="442" height="62" src="../../assets/img/common/tab_logo1.png"></router-link>
      </div>
        <!-- 右边导航栏信息 -->
      <div class="pad-top15 pad-bottom20 pad-right20 pad-left20 fl-left">
          <!-- oa登录等信息 -->
        <div class="w-100 h-30px">
            <ul class="h-30px h-100">
                <li class="nav-top-ul-li"><a href="https://www.ditcc.com/oa/home" target="_blank">OA登录</a></li>
                <li class="nav-top-ul-li"><router-link :to="{path:'/'}">中文</router-link>&nbsp;|&nbsp;<router-link :to="{path:'/en/index'}">English</router-link></li>
                <li class="nav-top-ul-li"><a href="javascript:;" @click="open()" v-if="!data_isLogin">注册/登录</a></li>
                <li class="nav-top-ul-li"><a href="javascript:;" @click="out()" v-if="data_isLogin">退出登录</a></li>
                <li class="nav-top-ul-li" v-if="data_isLogin && mesCount>0">
                  <router-link :to="{path:'/user/userMsg'}">
                    <span class="fl">用户中心</span>
                    <span class="fl notice-white"><font>{{mesCount}}</font></span>
                  </router-link>
                </li>
                <li class="nav-top-ul-li" v-if="data_isLogin && mesCount<1">
                  <router-link :to="{path:'/user/userInfo'}">
                    <span class="fl">用户中心</span>
                  </router-link>
                </li>
                <login :show.sync="show"></login>
            </ul>
        </div>
        <!-- 导航选择栏 -->
        <div class="w-100 mar-top10">
            <ul class="h-30px top-ul">
                <li class="nav-button-ul-li">
                  <router-link :to="{path:'/about/aboutCenter'}" :class="['ahover-item',setClass('aboutCenter')]">
                    关于我们
                    <img src="../../assets/img/common/nav_down.png" alt="">
                    <div class="ahover-show">
                      <p><router-link :to="{path:'/about/aboutCenter'}">中心介绍</router-link></p>
                      <p><router-link :to="{path:'/about/dyReportsList'}">动态报道</router-link></p>
                      <p><router-link :to="{path:'/about/parkInv'}">园区招商</router-link></p>
                      <p><router-link :to="{path:'/about/hatchEnpList'}">入孵企业</router-link></p>
                      <p><router-link :to="{path:'/about/joinUs'}">加入我们</router-link></p>
                      <p><router-link :to="{path:'/about/contactUs'}">联系我们</router-link></p>
                    </div>
                  </router-link>
                </li>
                <!-- <li class="nav-button-ul-li">
                  <a href="javascript:;">联盟机构</a>
                </li> -->
                <li class="nav-button-ul-li">
                  <router-link :to="{path:'/info/list'}" :class="setClass('info')">政策头条</router-link>
                </li>
                <li class="nav-button-ul-li">
                  <router-link :to="{path:'/demand/index'}" :class="['dhover-item',setClass('demand')]">
                    需求对接
                    <img src="../../assets/img/common/nav_down.png" alt="">
                    <div class="dhover-show">
                      <p><router-link :to="{path:'/demand/proList'}">项目需求</router-link></p>
                      <p><router-link :to="{path:'/demand/expList'}">专家需求</router-link></p>
                      <p><router-link :to="{path:'/demand/resList'}">融资需求</router-link></p>
                    </div>
                  </router-link>
                </li>
                <li class="nav-button-ul-li">
                  <router-link :to="{path:'/orgn/list'}" :class="setClass('orgn')">创投资本</router-link>
                </li>
                <li class="nav-button-ul-li">
                  <router-link :to="{path:'/expert/list'}" :class="setClass('expert')">专家智库</router-link>
                </li>
                <li class="nav-button-ul-li">
                  <router-link :to="{path:'/resource/list'}" :class="setClass('resource')">科创项目</router-link>
                </li>
                <li class="nav-button-ul-li">
                  <router-link :to="{path:'/'}" :class="setClass('index')">首页</router-link>
                </li>
            </ul>
        </div>
      </div>
    </div>

    <div v-if="toTop" class="nav-info w-100 bgc-ffffff c-392755" style="position:fixed;top:0;z-index:20;">
      <div class="mar-left30 fl-left">
          <a href=""><img width="442" height="62" src="../../assets/img/common/tab_logo2.png"></a>
      </div>
         <!-- 右边导航栏信息 -->
       <div class="pad-top15 pad-bottom20 pad-right20 pad-left20 fl-left">
           <!-- oa登录等信息 -->
         <div class="w-100 h-30px">
             <ul class="h-30px h-100">
                 <li class="nav-top-ul-li"><a href="https://www.ditcc.com/oa/home" target="_blank">OA登录</a></li>
                 <li class="nav-top-ul-li"><router-link :to="{path:'/'}">中文</router-link>&nbsp;|&nbsp;<router-link :to="{path:'/en/index'}">English</router-link></li>
                 <li class="nav-top-ul-li"><a href="javascript:;" @click="open()" v-if="!data_isLogin">注册/登录</a></li>
                 <li class="nav-top-ul-li"><a href="javascript:;" @click="out()" v-if="data_isLogin">退出登录</a></li>
                 <li class="nav-top-ul-li" v-if="data_isLogin && mesCount>0">
                   <router-link :to="{path:'/user/userMsg'}">
                     <span class="fl">用户中心</span>
                     <span class="fl notice-black"><font>{{mesCount}}</font></span>
                   </router-link>
                 </li>
                 <li class="nav-top-ul-li" v-if="data_isLogin && mesCount<1">
                   <router-link :to="{path:'/user/userInfo'}">
                     <span class="fl">用户中心</span>
                   </router-link>
                 </li>
             </ul>
         </div>
         <!-- 导航选择栏 -->
         <div class="w-100 mar-top10">
             <ul class="h-30px top-ul2">
                 <li class="nav-button-ul-li">
                   <router-link :to="{path:'/about/aboutCenter'}" :class="['ahover-item',setClass('aboutCenter')]">
                     关于我们
                     <img src="../../assets/img/common/nav_down2.png" alt="">
                     <div class="ahover-show">
                       <p><router-link :to="{path:'/about/aboutCenter'}">中心介绍</router-link></p>
                       <p><router-link :to="{path:'/about/dyReportsList'}">动态报道</router-link></p>
                       <p><router-link :to="{path:'/about/parkInv'}">园区招商</router-link></p>
                       <p><router-link :to="{path:'/about/hatchEnpList'}">入孵企业</router-link></p>
                       <p><router-link :to="{path:'/about/joinUs'}">加入我们</router-link></p>
                       <p><router-link :to="{path:'/about/contactUs'}">联系我们</router-link></p>
                     </div>
                   </router-link>
                 </li>
                 <!-- <li class="nav-button-ul-li">
                   <a href="javascript:;">联盟机构</a>
                 </li> -->
                 <li class="nav-button-ul-li">
                   <router-link :to="{path:'/info/list'}" :class="setClass('info')">政策头条</router-link>
                 </li>
                 <li class="nav-button-ul-li">
                   <router-link :to="{path:'/demand/index'}" :class="['dhover-item',setClass('demand')]">
                     需求对接
                     <img src="../../assets/img/common/nav_down2.png" alt="">
                     <div class="dhover-show">
                       <p><router-link :to="{path:'/demand/proList'}">项目需求</router-link></p>
                       <p><router-link :to="{path:'/demand/expList'}">专家需求</router-link></p>
                       <p><router-link :to="{path:'/demand/resList'}">融资需求</router-link></p>
                     </div>
                   </router-link>
                 </li>
                 <li class="nav-button-ul-li">
                   <router-link :to="{path:'/orgn/list'}" :class="setClass('orgn')">创投资本</router-link>
                 </li>
                 <li class="nav-button-ul-li">
                   <router-link :to="{path:'/expert/list'}" :class="setClass('expert')">专家智库</router-link>
                 </li>
                 <li class="nav-button-ul-li">
                   <router-link :to="{path:'/resource/list'}" :class="setClass('resource')">科创项目</router-link>
                 </li>
                 <li class="nav-button-ul-li">
                   <router-link :to="{path:'/'}" :class="setClass('index')">首页</router-link>
                 </li>
             </ul>
         </div>
       </div>
     </div>
  </div>
</template>

<script>
import login from '../../components/common/login.vue';
export default {
    name: 'top_lucency',
    props: ['selectItem'],
    inject:['reload'],
    data () {
      return {
        data_selectItem:this.$props.selectItem,
        toTop:false,
        show: false,
        data_isLogin: false,
        mesCount:0
      }
    },
    mounted () {
      window.addEventListener('scroll', this.handleScroll, true);

      this.$axios.get(this.global.url+'cl/isLogin').then( res => {
        this.data_isLogin = res.data;
        if(this.data_isLogin){
          this.data_isLogin = true;
          this.loadMeg();
        }
      }).catch( e => {})
    },
    components:{login},
    methods:{
      setClass(item){
        if(this.data_selectItem==item){
          return 'top-current';
        }
      },
      handleScroll(){
        // var scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
        //         document.body.scrollTop
        // var scroll = scrollTop - this.i;
        // const windowHeight = document.documentElement.clientHeight;
        // this.i = scrollTop;
        // if(scroll<0){
        //   if(scrollTop<10){
        //     this.toTop = false;
        //   }else{
        //     this.toTop = true;
        //   }
        // }else{
        //    this.toTop = false;
        // }

        var scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
                document.body.scrollTop
        // if(this.data_selectItem && this.data_selectItem=='index'){
        //   const windowHeight = document.documentElement.clientHeight;
        //   if(scrollTop>=windowHeight){
        //     this.toTop = true;
        //   }else{
        //      this.toTop = false;
        //   }
        // }else{
          if(scrollTop>=110){
            this.toTop = true;
          }else{
             this.toTop = false;
          }
        // }
      },open () {
        this.show = true;
      },toload(){
        this.reload();
      },out(){
        this.$axios.get(this.global.url+'cl/logOutHandle').then( res => {
          this.toload();
        }).catch( e => {})
      },loadMeg(){
        this.$axios.get(this.global.url+'user/msgNewCount').then( res => {
          this.mesCount = res.data?res.data:0;
        }).catch( e => {})
      }
    }
}
</script>

<style scoped>
  @import '../../assets/font/iconfont.css';
  @import '../../assets/css/common-distance.css';
  @import '../../assets/css/common-default.css';
  @import '../../assets/css/common-color.css';
  @import '../../assets/css/topAndfoot.css';
  @import '../../assets/css/common-layout.css';
  @import '../../assets/css/layui.css';
  @import '../../assets/css/client.css';
</style>
